import React from 'react';

const HowToPlayModal = ({ isOpen, onClose, isDarkMode = false }) => {
  if (!isOpen) return null;

  const closeModal = (event) => {
    if (event.currentTarget === event.target) {
      onClose();
    }
  };

  const textColor = isDarkMode ? '#e0e0e0' : '#555';
  const headingColor = isDarkMode ? '#ffffff' : '#333';
  const backgroundColor = isDarkMode ? '#1a1a1a' : '#ffffff';
  const borderColor = isDarkMode ? '#333' : '#eee';

  return (
    <div className="modal-backdrop" onClick={closeModal}>
      <div className="modal-content" style={{ maxWidth: '600px', backgroundColor }}>
        <div className="modal-header" style={{ backgroundColor }}>
          <h2 className="modal-title" style={{ fontSize: '24px', fontWeight: 'bold', color: headingColor }}>🎬 How To Play MovieQuest</h2>
          <button onClick={onClose} className="close-button">&times;</button>
        </div>
        <div className="modal-body modal-body-scroll" style={{ padding: '24px', lineHeight: '1.6', backgroundColor }}>
          <p style={{ fontSize: '16px', marginBottom: '20px', color: textColor }}>
            Guess the mystery movie using clues from each attempt!
          </p>

          <div style={{ marginBottom: '24px' }}>
            <h3 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '12px', display: 'flex', alignItems: 'center', color: headingColor }}>
              <span style={{ fontSize: '24px', marginRight: '8px' }}>🎯</span> Objective
            </h3>
            <p style={{ marginLeft: '32px', color: textColor }}>
              Identify the secret movie with the fewest guesses possible to maximize your score.
            </p>
          </div>

          <div style={{ marginBottom: '24px' }}>
            <h3 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '12px', display: 'flex', alignItems: 'center', color: headingColor }}>
              <span style={{ fontSize: '24px', marginRight: '8px' }}>🎮</span> How to Play
            </h3>
            <ol style={{ marginLeft: '32px', color: textColor }}>
              <li style={{ marginBottom: '12px' }}>
                <strong style={{ color: headingColor }}>Search & Select:</strong> Type a movie title and select from the dropdown
              </li>
              <li style={{ marginBottom: '12px' }}>
                <strong style={{ color: headingColor }}>Review Clues:</strong> Compare your guess across 7 categories: Director, Year, Genres, Cast, Runtime, Rating, Box Office
              </li>
              <li style={{ marginBottom: '12px' }}>
                <strong style={{ color: headingColor }}>Use Hints:</strong> Click "Get Hints" to reveal specific details (costs points!)
              </li>
              <li style={{ marginBottom: '12px' }}>
                <strong style={{ color: headingColor }}>Keep Guessing:</strong> Each guess narrows down the possibilities
              </li>
            </ol>
          </div>

          <div style={{ marginBottom: '24px' }}>
            <h3 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '12px', display: 'flex', alignItems: 'center', color: headingColor }}>
              <span style={{ fontSize: '24px', marginRight: '8px' }}>⚙️</span> Settings
            </h3>
            <ul style={{ marginLeft: '32px', color: textColor, listStyle: 'disc' }}>
              <li style={{ marginBottom: '8px' }}><strong style={{ color: headingColor }}>Year Range:</strong> Choose specific decades or all years</li>
              <li style={{ marginBottom: '8px' }}><strong style={{ color: headingColor }}>Easy Mode:</strong> Only popular blockbuster films</li>
              <li style={{ marginBottom: '8px' }}><strong style={{ color: headingColor }}>Hard Mode:</strong> All movies from the selected range</li>
            </ul>
          </div>

          <div style={{
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            padding: '16px',
            borderRadius: '8px',
            color: 'white',
            textAlign: 'center'
          }}>
            <p style={{ margin: 0, fontSize: '15px', fontWeight: '500' }}>
              🏆 Start with 1000 points • Lose points for wrong guesses & hints
            </p>
          </div>
        </div>
        <div className="modal-footer" style={{ padding: '16px 24px', borderTop: `1px solid ${borderColor}`, backgroundColor }}>
          <button
            onClick={onClose}
            className="close-modal-button"
            style={{
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              color: 'white',
              border: 'none',
              padding: '12px 32px',
              borderRadius: '8px',
              fontSize: '16px',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'transform 0.2s',
              width: '100%'
            }}
            onMouseOver={(e) => e.target.style.transform = 'scale(1.02)'}
            onMouseOut={(e) => e.target.style.transform = 'scale(1)'}
          >
            Let's Play! 🎬
          </button>
        </div>
      </div>
    </div>
  );
};

export default HowToPlayModal; 